import React, { Component } from "react"
import { Link } from "react-router-dom"
import Button from "../Button"
import PurchaseCard from "../PurchaseCard"
import Loading from "../Loading"
import { Waypoint } from "react-waypoint"
import moment from "moment"
import ProductCard from "../ProductCard"
import { showDownloadBtnForTrialUser } from "../../shared/helpers"
import AppContext from "../../shared/AppContext"
import Favorite, { FavoriteButton } from "../FavoriteButton"

import "./TsisETSDrillDown.scss"

class TsisETSDrillDown extends Component {
  constructor(props) {
    super(props)

    this.state = {
      hasMore: true,
    }
  }

  loadMoreOnScroll = () => {
    this.props.loadMoreOnScroll().then(({ data, loading, error }) => {
      if (!loading && !error && data.page.relatedProducts.length === 0) {
        this.setState({ hasMore: false })
      }
    })
  }

  renderFavoriteButton = () => {
    return (
      <Favorite
        className="rounded button-item"
        trackingLocation="Product View"
        favoriteData={{
          name: this.props.data.page.name,
          description: this.props.data.page.previewDescription,
          favoriteType:
            this.props.data.page.proprietaryDataset === "DataReport"
              ? "DATAREPORT"
              : "REPORT",
          slug: this.props.location.pathname,
          metadata: {
            productId: this.props.data.page.id,
            imageURL: this.props.data.page.logo,
          },
        }}
        favoriteType="REPORT"
        location={this.props.location}
        variables={{ productId: this.props.data.page.id }}
      >
        <FavoriteButton className="btn-favorite-outline-orange rounded button-item" />
      </Favorite>
    )
  }

  _renderButtons = () => {
    let { isSpecialAccess, isPurchased, files, free } = this.props.data.page

    const showDownload = showDownloadBtnForTrialUser(
      this.props.data.viewer,
      isPurchased,
      free
    )

    const hasFileToDownload = files && files.length && files[0].downloadUrl
    if (isSpecialAccess || free) {
      let canViewAndDownload = !!files && !!files[0]
      return (
        <div className="tpdetails-buttons-container">
          <div className="button-item">
            <Button
              classes={["dark-fill", "small-caps"]}
              fullWidth
              disabled={!canViewAndDownload}
              action={() => this.props.view()}
              data-cy="view-product-button"
            >
              View
              <span
                className="glyphicon glyphicon-eye-open"
                style={{ marginLeft: 5 }}
              />
            </Button>
          </div>
          {showDownload && (
            <div className="button-item">
              <Button
                classes={["green-fill", "small-caps"]}
                fullWidth
                download={
                  canViewAndDownload && hasFileToDownload
                    ? files[0].downloadUrl
                    : ""
                }
                action={this.props.download()}
                disabled={!canViewAndDownload || !hasFileToDownload}
                data-cy="download-product-button"
              >
                Download
                <span
                  className="glyphicon glyphicon-download-alt"
                  style={{ marginLeft: 5 }}
                />
              </Button>
            </div>
          )}

          {this.renderFavoriteButton()}
        </div>
      )
    } else {
      return (
        <div className="tpdetails-buttons-container">
          {this.props.purchase && <PurchaseCard {...this.props.purchase} />}
          <PurchaseCard
            subscription
            recommended
            description=""
            buttonText="INQUIRE FOR PRICING"
            buttonAction={() =>
              this.props.openInquireModal(
                this.props.serviceType.UpgradePlan,
                "Product Details Page: Inquire For Pricing Button"
              )
            }
            data-cy="purchase-card-inquire-button"
          />
          <div className="purchase-card-container">
            {this.renderFavoriteButton()}
          </div>
        </div>
      )
    }
  }

  render() {
    let {
      id,
      name,
      vendor,
      sector,
      description,
      publishDate,
      proprietaryDataset,
      metadata,
      relatedProducts,
      logo,
      free,
      dataReportSubtype,
    } = this.props.data.page

    description =
      description && description.replace(new RegExp("<br/>", "g"), "<br/><br/>")

    const formattedDate = formatDate(publishDate)

    let {
      N: sampleSize,
      ["Global 2000 N"]: global2000SampleSize,
      ["Fortune 500 N"]: fortune500SampleSize,
    } = metadata || {}

    let { ["Events Count"]: eventsCount, ["Page Count"]: pageCount } =
      metadata || {}

    const details =
      proprietaryDataset === "VEC"
        ? [
            {
              title: "Events Count",
              icon: "https://s3.amazonaws.com/dev-etr/images/events_count.png",
              value: eventsCount,
            },
            {
              title: "Page Count",
              icon: "https://s3.amazonaws.com/dev-etr/images/page_count.png",
              value: pageCount,
            },
            {
              title: "Publish Date",
              icon: "glyphicon glyphicon-calendar",
              value: formattedDate,
            },
          ]
        : [
            {
              title: "Survey Sample Size",
              icon: "glyphicon glyphicon-user",
              value: sampleSize,
            },
            {
              title: "Fortune 500 Citations",
              icon: "glyphicon glyphicon-briefcase",
              value: fortune500SampleSize,
            },
            {
              title: "Global 2000 Citations",
              icon: "glyphicon glyphicon-globe",
              value: global2000SampleSize,
            },
            {
              title: "Publish Date",
              icon: "glyphicon glyphicon-calendar",
              value: formattedDate,
            },
          ]

    let imgURL = logo
      ? logo
      : proprietaryDataset === "DataReport"
      ? "/static/images/data-report.png"
      : "https://s3.amazonaws.com/dev-etr/images/fallback/TSIS-PCAS.png"

    const tsisDisplayData = (
      <div>
        <h2>
          Technology Spending Intention Survey <span>Report Details:</span>
        </h2>
      </div>
    )

    const etsDisplayData = (
      <div>
        <h2>
          Emerging Technology Survey <span>Report Details:</span>
        </h2>
      </div>
    )

    return (
      <div>
        <div
          className={`tpdetails-overview-container ${
            free ? "free-report" : ""
          }`}
        >
          {free && (
            <div className="free-ribbon">
              <span>Free Report!</span>
            </div>
          )}
          <div className="tpdetails-image-container">
            <div
              style={{ backgroundImage: `url('${imgURL}')` }}
              className="image"
            />
          </div>
          <div className="tpdetails-title-container">
            <div id="title">
              <h1 className="title">{name}</h1>
            </div>
            <div id="vendor-sector">
              {vendor && vendor.length > 0 && (
                <h2>
                  <span className="vendor-sector-title">
                    Vendor{vendor.length > 1 ? "s" : ""}:{" "}
                  </span>
                  {vendor.map(({ slug, name }, i) => (
                    <span key={i}>
                      <Link key={i} to={`/vendor/${slug}`}>
                        {name}
                      </Link>
                      {i < vendor.length - 1 ? ", " : ""}
                    </span>
                  ))}
                </h2>
              )}
              {sector && sector.length > 0 && (
                <h2>
                  <span className="vendor-sector-title">
                    {" "}
                    Sector{sector.length > 1 ? "s" : ""}:
                  </span>{" "}
                  {sector.map(({ slug, name }, i) => (
                    <span key={i}>
                      <Link key={i} to={`/sector/${slug}`}>
                        {name}
                      </Link>
                      {i < sector.length - 1 ? ", " : ""}
                    </span>
                  ))}
                </h2>
              )}
            </div>
          </div>

          <div className="tpdetails-description-container">
            {description && (
              <p
                dangerouslySetInnerHTML={{ __html: description }}
                className="tpdetails-description"
              ></p>
            )}
          </div>
          {this._renderButtons()}
        </div>
        <div className="tpdetails-details-container">
          <h2>Details:</h2>
          <div className="tpdetails-details-content">
            {(() => {
              switch (proprietaryDataset) {
                case "DD":
                  return (
                    <h2>
                      Drill Down <span>Report Details:</span>
                    </h2>
                  )
                case "TSIS":
                  return tsisDisplayData
                case "DataReport":
                  return dataReportSubtype === "ETS"
                    ? etsDisplayData
                    : tsisDisplayData
                case "ETS":
                  return etsDisplayData
                case "VEC":
                  return (
                    <div>
                      <h2>
                        {" "}
                        VEC <span>Report Details:</span>
                      </h2>
                    </div>
                  )
              }
            })()}
            <div className="tpdetails-details-inner-container">
              {details.map(
                ({ icon, value, title }, i) =>
                  !!value && (
                    <div className="detail-item" key={i}>
                      <div className="tpdetails-details-image-placeholder">
                        {title === "Events Count" || title === "Page Count" ? (
                          <div
                            className="detail-icon"
                            style={{ backgroundImage: `url('${icon}')` }}
                          />
                        ) : (
                          <span className={icon} />
                        )}
                      </div>
                      <h3>{value}</h3>
                      <h4>
                        {name} {title}
                      </h4>
                    </div>
                  )
              )}
            </div>
          </div>
        </div>

        <div className="product-related-products-container">
          <h2>Related:</h2>
          <RelatedProductsList products={relatedProducts} parentId={id} />
          {this.state.hasMore && !this.props.loading && (
            <div id="loading-more-products">
              <Waypoint onEnter={this.loadMoreOnScroll} />
              <Loading />
            </div>
          )}
        </div>
      </div>
    )
  }
}

const formatDate = (date) => {
  return date && moment(date).format("Do MMM YYYY")
}

const RelatedProductsList = (props) => {
  return (
    <div className="tpdetails-related-products-list">
      {props.products &&
        props.products.map((product, idx) =>
          product.id !== props.parentId ? (
            <ProductCard {...product} key={idx} />
          ) : null
        )}
    </div>
  )
}

const TsisETSDrillDownWithContext = (props) => {
  return (
    <AppContext.Consumer>
      {({ openInquireModal, serviceType }) => {
        return (
          <TsisETSDrillDown
            {...props}
            openInquireModal={openInquireModal}
            serviceType={serviceType}
          />
        )
      }}
    </AppContext.Consumer>
  )
}

export default TsisETSDrillDownWithContext
